<ion-app>
  <ion-menu #menu side="end" menuId="first" contentId="main">
    <ion-header *ngIf="user && user.selectedGroup" class="ion-no-border">
      <ion-toolbar style="line-height: 0.9em;">
        <ion-avatar style="padding: 8px;" slot="start">
          <ion-img [src]="!user.image ? '../../assets/icon/tempo-user.png' : user.image"></ion-img>
        </ion-avatar>
        <ion-label color="primary" style="font-weight: bold; font-size:medium">{{user.selectedGroup.anonymous_users ? hiddenUid() : user.displayName}}<br><span
            style="font-size: 0.7rem; font-weight: normal; color: var(--ion-text-color);">{{user.email}}</span></ion-label>
        <ion-buttons slot="end">
          <ion-button (click)="menu.close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content *ngIf="user && user.selectedGroup">

      <ion-list lines="none">

        <ion-list-header>
          <ion-label color="primary">Menu</ion-label>
        </ion-list-header>
        <!-- <ion-item (click)="menu.close() && unlockGroup()">
          Inserisci codice invito
        </ion-item>
         -->

        <ion-item (click)="qrcodeReader()">
          <ion-icon name="qr-code-outline" slot="start" />
          <ion-label>Lettore QR Code</ion-label>
        </ion-item>
        <ion-item (click)="showTerms()" routerLink="terms">
          <ion-icon name="shield-checkmark-outline" slot="start" />
          <ion-label>Termini e Condizioni</ion-label>
        </ion-item>
        @if (user.selectedGroup.custom_privacy) {
          <ion-item (click)="showGroupPrivacy()">
            <ion-icon name="lock-closed-outline" slot="start" />
            <ion-label>La tua privacy</ion-label>
          </ion-item>
        }
        

        <ion-item (click)="showProfile()">
          <ion-icon name="person-circle-outline" slot="start" />
          <ion-label>Profilo</ion-label>
        </ion-item>


        <!-- <ion-item (click)="showUserData()">
          <ion-icon name="finger-print-outline" slot="start" />
          <ion-label>I tuoi dati</ion-label>
        </ion-item>
        <ion-item (click)="logout()">
          <ion-icon name="log-out-outline" slot="start" />
          <ion-label>Esci</ion-label>
        </ion-item>
        <ion-item *ngIf="user.selectedGroup.gid!=1" (click)="leaveGroup()">
          <ion-icon name="close-outline" slot="start" />
          <ion-label>Abbandona {{user.selectedGroup.name}}</ion-label>
        </ion-item>
        <ion-item (click)="deleteUser()">
          <ion-icon name="person-remove-outline" slot="start" />
          <ion-label>Elimina account</ion-label>
        </ion-item> -->
        <ion-list-header>
          <ion-label color="primary">Canali</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let group of user.unlockedGroups" (click)="selectGroup(group)">
          <ion-avatar style="border: 2px var(--ion-color-medium) solid; padding: 2px;" slot="start">
            <img [src]="group.image" style="object-fit: contain;">
          </ion-avatar>
          <ion-label>{{group.name}}</ion-label>
          <ion-icon *ngIf="user.selectedGroup.gid == group.gid" slot="end" name="checkmark" color="primary"></ion-icon>
        </ion-item>

      </ion-list>
    </ion-content>
    <ion-footer class="ion-padding ion-no-border">
      <div><strong>{{appVersion}} {{env}}</strong></div>
      <div style="margin-bottom: 8px;">{{appBuild}}</div>
    </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>